<template>
  <div class="resetSuccess">
    <v-card class="py-8 px-10">
      <h3 class="mb-6 text-center">重置成功</h3>
      <div class="information">
        <div>您已成功重置密碼</div>
        <v-icon color="green">fa-check-double</v-icon>
        <v-btn block rounded color="pink" to="/">開始購物</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  created() {
    this.getUserInformation()
  },
  methods: {
    getUserInformation() {
      this.$store.dispatch('user/setToken', `Bearer ${this.$route.query.token}`)
      this.axios.get('/member').then(response => {
        this.$store.dispatch('user/setUser', response.data)
      })
    },
  }
}
</script>

<style lang='scss'>
.resetSuccess {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    .v-icon {
      display: block;
      margin: 20px 0;
      font-size: 70px;
    }
    .information {
      text-align: center;
      & > div {
        font-size: 14px;
      }
    }
  }
}
</style>